import React, { useState } from 'react';
import { GridCol } from '@naf/grid';
import { Loader } from '@naf-simba/building-blocks-loaders';
import { Text, TextVariant } from '@naf/text';
import { VehicleObject } from '@appTypes/myVehiclesType';
import RequestOfferInput from '../RequestOfferInput/RequestOfferInput';
import { RegisteredVehicle } from '../RegisteredVehicle/RegisteredVehicle';
import { VehicleTypesToShow } from './VehicleSelecter.utils';
import * as S from './VehicleSelecter.styles';

interface VehicleSelecterProps {
  isAuthenticated?: boolean;
  isLoading?: boolean;
  isUpdatingVehicles?: boolean;
  myVehicles?: Record<string, { licensePlateNumber: string; manufactureName: string; modelName: string }>;
  isWorkshopPage?: boolean;
  pageType?: string;
  onSelectedVehicleClick?: (licensePlateNumber: string) => void;
}

export const VehicleSelecter = ({
  isAuthenticated,
  isLoading,
  isUpdatingVehicles,
  myVehicles,
  isWorkshopPage,
  pageType,
  onSelectedVehicleClick,
}: VehicleSelecterProps) => {
  const [licensePlateNumber, setLicensePlateNumber] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  const handleRequestClick = () => {
    if (!licensePlateNumber.trim()) {
      setError('Vennligst fyll inn registreringsnummer');
      return;
    }

    setError(null);
    onSelectedVehicleClick?.(licensePlateNumber.trim());
  };

  if (isAuthenticated && (isLoading || isUpdatingVehicles) && isWorkshopPage) {
    return <Loader />;
  }

  if (
    isAuthenticated &&
    !isLoading &&
    !isUpdatingVehicles &&
    isWorkshopPage &&
    myVehicles &&
    Object.values(myVehicles).length > 0
  ) {
    return (
      <GridCol s="12" m="12" l="12" xl="12">
        <Text variant={TextVariant.Header3}>Hvilken bil ønsker du å motta uforpliktende tilbud på {pageType} for?</Text>
        <Text>Disse bilene er registrert på deg</Text>
        <S.RegisteredVehiclesContainer>
          {Object.values(myVehicles)
            .filter((vehicle: VehicleObject) => VehicleTypesToShow.includes(vehicle.vehicleType))
            .map((vehicle) => (
              <RegisteredVehicle
                key={vehicle.licensePlateNumber}
                plateNumber={vehicle.licensePlateNumber}
                manufactureName={vehicle.manufactureName}
                modelName={vehicle.modelName}
                onVehicleClick={() => onSelectedVehicleClick?.(vehicle.licensePlateNumber)}
              />
            ))}
        </S.RegisteredVehiclesContainer>
        <RequestOfferInput
          licensePlateNumber={licensePlateNumber}
          setLicensePlateNumber={setLicensePlateNumber}
          handleRequestClick={handleRequestClick}
          error={error}
          pageType={pageType}
        />
      </GridCol>
    );
  }

  return (
    <GridCol s="12" m="12" l="12" xl="12">
      <RequestOfferInput
        licensePlateNumber={licensePlateNumber}
        setLicensePlateNumber={setLicensePlateNumber}
        handleRequestClick={handleRequestClick}
        error={error}
        pageType={pageType}
      />
    </GridCol>
  );
};

export default VehicleSelecter;
